import { HTMLAttributes } from "react"

import { cn } from "@/lib/utils"
import { IconLoader, IconProps } from "@tabler/icons-react"

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: IconProps["size"]
  className?: string
}

export const Spinner = ({ size = 32, className, ...props }: SpinnerProps) => {
  return (
    <div
      className={cn("flex h-full items-center justify-center", className)}
      {...props}
    >
      <IconLoader size={size} className="animate-spin" />
    </div>
  )
}
